import React, { useRef } from 'react';
import FractionalHeroSection from '../../../components/landingPage/FractionalPage/FractionalHeroSection';
import FractionalStatBand from '../../../components/landingPage/FractionalPage/FractionalStatBand';
import FractionHelpSection from '../../../components/landingPage/FractionalPage/FractionHelpSection';
import FractionalCarouselSection from '../../../components/landingPage/FractionalPage/FractionalCarouselSection';
import FractionalProcessSection from '../../../components/landingPage/FractionalPage/FractionalProcessSection';
import FractionalCtaSection from '../../../components/landingPage/FractionalPage/FractionalCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import useDocumentHead from '../../../components/landingPage/AeoArticles/useDocumentHead';
import hubWebPageSchema from '../../../components/landingPage/AeoArticles/aeoHubSchema';
import { AEO_HUBS } from '../../../components/landingPage/AeoArticles/aeoArticlesData';

const Fractional = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);
    useDocumentHead({ canonicalPath: `${AEO_HUBS['cfo']['hubPath']}/`, schema: hubWebPageSchema('cfo') });

    return (
        <div className="lp-page" ref={rootRef}>
            <FractionalHeroSection />
            <FractionalStatBand />
            <FractionHelpSection />
            <FractionalCarouselSection />
            <FractionalProcessSection />
            <FractionalCtaSection />
            <AeoResourcesSection icpSlug="cfo" />
        </div>
    );
};

export default Fractional;
